import { Requester } from '@revenuemarket/http';
import { AxiosError } from 'axios';
import { getCookie } from 'cookies-next';

import { signOut } from '~apis/auth/signin';
import { API_URL } from '~constants/env';
import { appendUtmToUrlString } from '~utils/session/utmSession';

export const getDomainForCookie = () => {
  if (typeof window === 'undefined') return '';

  const host = location.hostname;

  // localhost 처리
  if (host.includes('localhost')) {
    return 'localhost';
  }

  // vercel 임시 도메인 처리
  if (host.includes('vercel')) {
    return `.${host}`;
  }

  // finance.cloud 도메인 처리
  if (host.endsWith('.finance.cloud')) {
    return '.finance.cloud';
  }

  // clobe.ai 도메인 처리 (기본값)
  return '.clobe.ai';
};

export const SignInAPI = new Requester(API_URL as string, undefined, {
  timeout: 3000,
});

export const API = new Requester(API_URL as string, undefined, {});

API.Instance.interceptors.request.use((config) => {
  // URL에 "signin"이 포함되어 있는지 확인
  if (config?.url && config?.url?.includes('sign-in')) {
    // "signin"이 URL에 포함된 경우 accessToken 검사 건너뛰기
    return config; // 요청을 계속 진행합니다.
  }

  try {
    const accessToken =
      typeof window !== 'undefined'
        ? getCookie('access_super_token') || getCookie('accessToken')
        : config?.params?.accessToken;

    if (!accessToken) {
      // 토큰이 없을 경우 요청을 거부 (Sentry에 잡히지 않도록 빈 에러 객체 사용)
      return config;
    }

    if (accessToken && accessToken !== 'undefined') {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
  } catch (error) {
    console.error('Interceptor error:', error);
    // 에러가 발생해도 요청을 계속 진행할 수 있도록 처리
  }

  return config; // 요청을 계속 진행합니다.
});

const axiosOnRejected = async (err: AxiosError) => {
  if (err.response?.status === 401) {
    await signOut();
    if (typeof window !== 'undefined' && !window.location.href.includes('/auth/signin')) {
      window.location.href = appendUtmToUrlString('/auth/signin');
    }
  }
  return Promise.reject(err);
};

API.Instance.interceptors.response.use((res) => res, axiosOnRejected);
